/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = "is-active";
	const v = "is-visible";
	const _pagepath = "/solution/";
	const categoryPageMap = {
		logistics: 0,
		core: 1,
		application: 2,
		dx: 3,
		infrastructure: 4,
	};
	const category1Map = {
		"tag4-1": "ロジスティクス",
		"tag4-2": "基幹業務",
		"tag4-3": "アプリ構築",
		"tag4-4": "DX支援",
		"tag4-5": "インフラ",
	};
	const category2Map = {
		warehouse: "倉庫管理システム",
		operation: "運行管理支援システム",
		vehicle: "配車管理システム",
		manual: "マニュアル作成支援",
		device: "デバイスソリューション",
		bi: "データ可視化支援（BI）",
		automation: "自動化ソリューション",
		consulting: "コンサルティング",
		erp: "ERP及び周辺ソリューション",
		webapplication: "Webアプリ構築",
		mobileapp: "モバイルアプリ構築",
		cloud: "クラウドソリューション",
		"low-code-no-code": "ローコード・ノーコード開発",
		migration: "マイグレーションサービス",
		"ba-ai": "データ分析支援（BA/AI）",
		"etl-dwh": "データ活用基盤構築（ETL/DWH）",
		generationai: "生成AI活用支援",
		workflow: "ワークフロー",
		telework: "テレワークソリューション",
		virtualization: "仮想化ソリューション",
		asset: "資産管理",
		security: "セキュリティ",
		infrastructure: "インフラ導入検討支援サービス",
		cloud: "クラウドソリューション",
	};

	const initSwiper = (selector, options = {}) => {
		const defaultOptions = {
			type: "loop",
			perPage: 2,
			autoplay: false,
			arrows: true,
			pagination: true,
			paginationKeyboard: true,
			gap: 20,
			breakpoints: {
				1025: {
					perPage: 1,
					gap: 0,
				},
			},
		};

		const finalOptions = { ...defaultOptions, ...options };

		document.querySelectorAll(selector).forEach((element) => {
			new Splide(element, finalOptions).mount();
		});
	};

	initSwiper(".solution-LineupSlide.splide", {
		autoplay: false,
		interval: 3000,
	});

	const introductionSlide = () => {
		const introductionSlider = document.querySelector(".mod-introductionSlide");
		if (introductionSlider) {
			const slideItems = introductionSlider.querySelectorAll(".splide__slide");
	
			const splide = new Splide(".mod-introductionSlide.splide", {
				type: "loop",
				perPage: 1,
				autoplay: false,
				interval: 5000,
				speed: 500,
				arrows: slideItems.length > 1, // スライドが1つなら矢印を非表示
				pagination: true,
				paginationKeyboard: true,
			}).mount();
		}
	};

	const pickupSlide = () => {
		const pickupSlider = document.querySelector(".mod-pickupSlide");
		if (pickupSlider) {
			const slideItems = pickupSlider.querySelectorAll(".splide__slide");
	
			const splide = new Splide(".mod-pickupSlide.splide", {
				type: "loop",
				perPage: 1,
				autoplay: false,
				interval: 5000,
				speed: 500,
				arrows: slideItems.length > 1, // スライドが1つなら矢印を非表示
				pagination: true,
				paginationKeyboard: true,
			}).mount();
		}
	};
	const fetchCSVData = () => {
		return fetch("../list/list.csv").then((response) => {
			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}
			return response.text();
		});
	};
	const fetchJSONData = () => {
		return fetch("/ajax/news/list.json").then((response) => {
			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}
			return response.json();
		});
	};

	const pickupCatInsert = (data) => {
		const items = document.querySelectorAll(".rt_key");

		items.forEach((item) => {
			const rtKeyValue = item.textContent.trim(); // rt_key の値を取得

			const matchedData = data.rt_bn_news_list.find((news) => {
				return news._key === rtKeyValue; // JSON の _key と一致するかチェック
			});

			const solCategory = document.querySelector(".js-category");
			if (solCategory) {
				if (matchedData) {
					const tagElement = item
						.closest(".__item")
						.querySelector(".js-category");
					if (tagElement) {
						tagElement.textContent = `${matchedData.cf_n_category.cf_nc_name}`;
					}
				}
			}
		});
	};

	const solutionCatInsert = (data) => {
		const items = document.querySelectorAll(".rt_key");

		items.forEach((item) => {
			const rtKeyValue = item.textContent.trim(); // rt_key の値を取得

			const matchedData = data.rt_bn_news_list.find((news) => {
				return news._key === rtKeyValue; // JSON の _key と一致するかチェック
			});

			const solutionCat = document.querySelector(".js-solutionCat");
			if (solutionCat) {
				if (matchedData) {
					const tagElement = item
						.closest(".__item")
						.querySelector(".js-solutionCat");
					if (tagElement) {
						tagElement.textContent = `${matchedData.cf_n_category.cf_nc_name}`;
					}
				}
			}
		});
	};

	const solutionTagInsert = (data) => {
		const items = document.querySelectorAll(".rt_key");

		items.forEach((item) => {
			const rtKeyValue = item.textContent.trim(); // rt_key の値を取得

			const matchedData = data.rt_bn_news_list.find((news) => {
				return news._key === rtKeyValue; // JSON の _key と一致するかチェック
			});

			const tags = document.querySelector(".mod-tags");
			if (tags) {
				if (matchedData) {
					const tagContainer = item
						.closest(".__column_3")
						.querySelector(".mod-tags");
					if (tagContainer) {
						// 一旦既存のタグを削除
						tagContainer.innerHTML = "";

						// cf_n_related_solutions の cf_nt_name_d をループしてタグを生成
						matchedData.cf_n_tags.forEach((tag) => {
							const newTag = document.createElement("li");
							newTag.classList.add("js-tagSolution");

							const tagSpan = document.createElement("span");
							tagSpan.classList.add("__tag");
							tagSpan.textContent = `${tag.cf_nt_name_d}`; // cf_nt_name_dプロパティを利用

							newTag.appendChild(tagSpan);
							tagContainer.appendChild(newTag);
						});
					}
				}
			}
		});
	};

	const splitIgnoringCommasInQuotes = (str) => {
		const result = [];
		let current = "";
		let inQuotes = false;

		for (let i = 0; i < str.length; i++) {
			const char = str[i];

			if (char === '"') {
				inQuotes = !inQuotes;
			}

			if (char === "," && !inQuotes) {
				result.push(current);
				current = "";
			} else {
				current += char;
			}
		}

		if (current) {
			result.push(current);
		}

		return result;
	};

	const solutionDetailFiltering = (data) => {
		const genCardLi = (news, ul) => {
			const [id, , name, logo, , summary, detailUrl, ...rest] = news;

			// .pngを削除
			const cleanLogo = logo ? logo.replace(/\.png$/, "") : "logo";

			// 小カテゴリを適切に取得
			const tag5 = rest[rest.length - 1];

			// 大カテゴリを取得
			const categories = rest.slice(0, rest.length - 1);

			const majorCategories = categories
				.map((tag, index) => (tag === "1" ? `tag4-${index + 1}` : null))
				.filter((tag) => tag !== null);
			const listItem = document.createElement("li");
			listItem.classList.add("__column_2");
			listItem.innerHTML = `
					${
						detailUrl
							? `<a href="${detailUrl}" class="__itemList">`
							: `<div class="__itemList">`
					}
							<div class="">
													<div class="mod-labelWrap">
															${majorCategories
																.map(
																	(tag4) =>
																		`<span class="mod-label _pink" data-key="${tag4}">${
																			category1Map[`${tag4}`.toLowerCase()]
																		}</span>`
																)
																.join(" ")}
															<span class="mod-label" data-key="${tag5}">${
				category2Map[`${tag5}`.toLowerCase()]
			}</span>
													</div>
											</div>
							<div class="__itemList-in">
									<picture>
											${
												cleanLogo
													? `
											<source srcset="/images/solution/top/${cleanLogo}.webp" media="(max-width:767px)">
											<img src="/images/solution/top/${cleanLogo}.webp" alt="" loading="lazy" class="width-u-100">`
													: ""
											}
									</picture>
									<div class="__ttl">
											<p class="mod-spacer_8 mod-head04 fw_bold">${name}</p>
									</div>
							</div>

							<p class="mod-spacer_16">${summary.replace(/"/g, "")}</p>
					</a>
			`;
			ul.appendChild(listItem);
		};
		const solutionDetailList = document.querySelectorAll(
			".solution-detail-category h3"
		);

		const currPathname = location.pathname
			.replace(_pagepath, "")
			.replace(/\//, "");
		const currCategoryNum = categoryPageMap[currPathname];
		solutionDetailList.forEach((item) => {
			const ul = item.nextElementSibling;
			ul.innerHTML = "";
			const name = item.textContent.trim();
			const filterNewsByTagName = (data) => {
				const key = Object.keys(category2Map).find(
					(key) => category2Map[key] === name
				);
				return data.filter((news) => {
					const newsList = splitIgnoringCommasInQuotes(news);
					const [id, , name, logo, , summary, detailUrl, ...rest] = newsList;
					const categories = rest.slice(0, rest.length - 1);
					const isMatchedCategory = categories[currCategoryNum] == "1";
					const category = newsList[newsList.length - 1];
					return category == key && isMatchedCategory;
				});
			};
			const filteredNews = filterNewsByTagName(data.split("\r\n"));
			filteredNews.forEach((news) => {
				genCardLi(splitIgnoringCommasInQuotes(news), ul);
			});
		});
	};

	fetchCSVData()
		.then((data) => {
			solutionDetailFiltering(data);
		})
		.catch((error) => {
			console.error("Error fetching CSV data:", error);
		});
	fetchJSONData()
		.then((data) => {
			pickupCatInsert(data);
			solutionCatInsert(data);
			solutionTagInsert(data);
		})
		.catch((error) => {
			console.error("Error fetching JSON data:", error);
		});
	initSwiper();
	introductionSlide();
	pickupSlide();
})(window.FUNCTIONS);
